/* MrSneaker collection: collapsible facets, auto-submit, mobile toggle.
   Rule: selecting any size automatically restricts results to that size being IN STOCK. */
(function () {
  'use strict';
  var SIZE_PREFIX = 'filter.v.option.';
  var AVAIL = 'filter.v.availability';

  function urlHasSize(params) {
    var found = false;
    params.forEach(function (v, k) { if (k.indexOf(SIZE_PREFIX) === 0) found = true; });
    return found;
  }

  /* Safety net: if a size is in the URL without in-stock, rewrite the URL once. */
  function enforceFromUrl() {
    if (!window.URLSearchParams) return false;
    var params = new URLSearchParams(window.location.search);
    if (!urlHasSize(params)) return false;
    var av = params.getAll(AVAIL);
    if (av.length === 1 && av[0] === '1') return false;
    params.delete(AVAIL);
    params.append(AVAIL, '1');
    window.location.replace(window.location.pathname + '?' + params.toString());
    return true;
  }

  /* Before submitting: if a size is ticked, force in-stock. */
  function forceInStock(form) {
    var sizeChecked = form.querySelector('input[name^="' + SIZE_PREFIX + '"]:checked');
    var hidden = form.querySelector('[data-force-stock]');
    var inBox = form.querySelector('input[name="' + AVAIL + '"][value="1"]');
    var outBox = form.querySelector('input[name="' + AVAIL + '"][value="0"]');
    if (!sizeChecked) {
      if (hidden) hidden.parentNode.removeChild(hidden);
      return;
    }
    if (outBox) outBox.checked = false;
    if (inBox) { inBox.checked = true; return; }
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = AVAIL;
      hidden.value = '1';
      hidden.setAttribute('data-force-stock', '');
      form.appendChild(hidden);
    }
  }

  function cleanEmpty(form) {
    form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
  }

  function init() {
    if (enforceFromUrl()) return;
    var form = document.querySelector('[data-mcol-form]');
    if (!form || form.dataset.mInit === '1') return;
    form.dataset.mInit = '1';

    form.querySelectorAll('[data-auto]').forEach(function (el) {
      el.addEventListener('change', function () {
        forceInStock(form);
        cleanEmpty(form);
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });

    form.addEventListener('submit', function () { forceInStock(form); cleanEmpty(form); });

    var toggle = form.querySelector('[data-filter-toggle]');
    var side = form.querySelector('[data-side]');
    if (toggle && side) {
      toggle.addEventListener('click', function () { side.classList.toggle('is-open'); });
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
